import * as React from "react";

import {
	List,
	Datagrid,
	ListProps,
	BooleanField,
	DateField,
	TextField,
	ReferenceField,
	useGetIdentity,
	FunctionField,
	TopToolbar,
	CreateButton,
	usePermissions,
} from "react-admin";
import { DOCTOR_SALE_SHARE } from "../constants";
import labelsTranslation from "../translations/tranlation";

import Pagination from "../Components/Pagination";
import { DOCTORSALE_TITLE_FIELD } from "../doctorSale/DoctorSaleTitle";

const ListActions = () => (
	<TopToolbar>
		<CreateButton
			label={`ثبت اطلاعات ${labelsTranslation.userList.createButton}`}
		/>
	</TopToolbar>
);

export const PatientList = (props: ListProps): React.ReactElement => {
	const { identity, loaded } = useGetIdentity();
	return (
		<>
			{loaded && (
				<List
					{...props}
					bulkActionButtons={false}
					perPage={50}
					actions={<ListActions />}
					pagination={<Pagination />}
					title={labelsTranslation.userList.title}
					filter={{
						doctorId: {
							equals: identity?.id,
						},
					}}
				>
					<Datagrid rowClick="show">
						<FunctionField
							label={"نام و نام خانوادگی"}
							render={(record: any) => `${record.firstName} ${record.lastName}`}
							sortable={false}
						/>
						<TextField label="موبایل" source="mobile" sortable={false} />
						<TextField
							style={{
								whiteSpace: "pre-line",
							}}
							label={labelsTranslation.userList.comment}
							source="doctorComment"
							sortable={false}
						/>
						<DateField
							source="createdAt"
							label="تاریخ ثبت"
							locales={"fa-IR"}
							sortable={false}
						/>
						<DateField
							source="updatedAt"
							label="تاریخ بروزرسانی"
							locales={"fa-IR"}
							sortable={false}
						/>

						<ReferenceField
							link={false}
							label="تاریخ خرید"
							source="doctorSale.id"
							reference="DoctorSale"
							sortable={false}
						>
							<DateField source="saleDate" locales={"fa-IR"} />
						</ReferenceField>
						<ReferenceField
							link={false}
							label="سهم شما"
							source="doctorSale.id"
							reference="DoctorSale"
							sortable={false}
						>
							<FunctionField
								label="سهم شما"
								render={(record: any) =>
									record.saleDate ? DOCTOR_SALE_SHARE : 0
								}
							/>
						</ReferenceField>
						{/* <BooleanField label="ارشیو" source="archived" /> */}
						{/* <TextField label="Doctor" source="doctor.firstName" /> */}
						{/* <TextField label="Doctor Comment" source="doctorComment" /> */}
						{/* <TextField label="Doctor Id" source="doctorId" /> */}

						{/* <TextField label="نام" source="firstName" /> */}
						{/* <TextField label="نام خانوادگی" source="lastName" /> */}
						{/* <TextField label="ID" source="id" /> */}
						{/* <TextField
					label="Sale Representative Comment"
					source="saleRepresentativeComment"
				/> */}
					</Datagrid>
				</List>
			)}
		</>
	);
};
